module.exports = __webpack_public_path__ + "assets/img/5-4.c27f54c6.png";